import React from "react";
import "./Button.css";

class Button extends React.Component {

  onClick = e => {
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  }

  render() {
    const { label, disabled, name } = this.props;
    var estilo;
    if (name === 'inicio')
      estilo = 'ha-b2 ha-bp2'
    else 
      estilo = 'ha-b ha-bp'

    return (
      <button 
        ref={input => { this.buttonElement = input; }} 
        className={estilo} 
        onClick={this.onClick} 
        disabled={disabled}>
          {label}
      </button>
    );
  }
}

export default Button;
